var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"b-event-month-card__wrapper"},_vm._l((_vm.events),function(event,index){return _c('EventMonthCard',{key:index,attrs:{"event":event},nativeOn:{"click":function($event){return _vm.$emit("openEvent", event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }